import events from '../events';
import usersApiClient from '../login-register/UsersApiClient';
export function ForgotPassword() {
    return {
        errorMessage: '',
        success: false,
        isLoading: false,
        submit(e) {
            const email = e.target.email.value;
            if (email) {
                this.errorMessage = '';
                this.isLoading = true;
                usersApiClient.requestResetPassword(email)
                    .then(success => {
                    this.success = success;
                })
                    .catch(err => {
                    if (err.status === 400) {
                        this.errorMessage = err.data[0].errorMessage;
                    }
                    else {
                        this.errorMessage = 'Noe gikk galt';
                    }
                })
                    .finally(() => this.isLoading = false);
            }
        },
        login() {
            events.openLogin.trigger({ open: true, centeredFixed: true });
        },
    };
}
